import type { RootState } from 'store';

export const badgeCountsSelector = (state: RootState) => state.admin.adminGlobal.badgeCounts;

export const notificationsSelector = (state: RootState) => state.admin.adminGlobal.notifications;

export const loadingNotificationsSelector = (state: RootState) =>
  state.admin.adminGlobal.loadingNotifications;

export const loadingMoreNotificationsSelector = (state: RootState) =>
  state.admin.adminGlobal.loadingMoreNotifications;
